module.exports = __webpack_public_path__ + "static/media/dsr_trainer1.bf7bb35b.svg";